<template>
  <div>
    <!-- 阿龜資料讀取畫面 -->
    <div v-if="loading">
      <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
    </div>

    <b-card
      v-if="table_items.length > 0"
      class="list-table-result scroll-style-gray overflow-x"
    >
      <b-table
        id="admin-project-table"
        hover
        small
        responsive="xl"
        :fields="table_fields"
        :items="table_items"
      >
        <!-- A virtual column -->
        <template #cell(name)="row">
          <b-button
            variant="outline-success"
            :to="{
              name: 'Project Summary',
              params: { projectID: row.item.id },
            }"
          >
            {{ row.item.name }}
          </b-button>

          <router-link
            class="router-button"
            :to="{
              name: 'Project Management',
              params: { projectID: row.item.id },
            }"
          >
            <i class="fa fa-pencil-square"></i>
          </router-link>
        </template>

        <template #cell(service_level)="row">
          <div :class="'service-level level-' + row.item.service_level">
            <i class="fa fa-shield"></i>
            {{ $t("status.service_level." + row.item.service_level) }}
          </div>
        </template>

        <template #cell(status)="row">
          <b-badge v-if="row.item.status == 'activate'" variant="success">{{
            $t("status.project.activate")
          }}</b-badge>
          <b-badge v-if="row.item.status == 'done'" variant="secondary">{{
            $t("status.project.done")
          }}</b-badge>
          <b-badge v-if="row.item.status == 'suspend'" variant="dark">{{
            $t("status.project.suspend")
          }}</b-badge>
        </template>

        <template #cell(cropperiods)="row">
          <div class="cropperiod-buttons">
            <div
              class="block-text"
              v-for="cropperiod in row.item.cropperiods"
              :key="cropperiod.id"
            >
              <b-button
                class="btn-cp"
                :to="{
                  name: 'Cropperiod',
                  params: {
                    projectID: row.item.id,
                    cropperiodID: cropperiod.id,
                  },
                }"
              >
                {{ cropperiod.name }}
              </b-button>

              <router-link
                class="router-button"
                :to="{
                  name: 'Cropperiod Management',
                  params: {
                    projectID: row.item.id,
                    cropperiodID: cropperiod.id,
                  },
                }"
              >
                <i class="fa fa-pencil-square"></i>
              </router-link>
            </div>
          </div>
        </template>

        <!-- <template #cell(details)="row">
                    <b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-warning">
                        {{ row.detailsShowing ? 'Hide' : 'Show'}}
                    </b-button>
                </template>
                <template #row-details="row">
                    {{ row.item }}
                </template> -->
      </b-table>

      <!-- 分頁 -->
      <div v-if="search" class="justify-content-center">
        <b-pagination
          v-model="search.current_page"
          :total-rows="search_settings.data_count"
          :per-page="search_settings.per_page"
          aria-controls="records-list"
          pills
          align="center"
        ></b-pagination>
      </div>
      <div class="text-center">
        {{ $t("menu.data_count") }}：{{ search_settings.data_count }}
      </div>
    </b-card>
    <div v-else>
      <NoData></NoData>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/views/components/NoData";
import AgriLoading from "@/views/components/AgriLoading";
// import StressAlertList from '@/views/components/StressAlertList'

export default {
  components: {
    NoData,
    AgriLoading,
    // StressAlertList,
  },
  data() {
    return {
      loading: false,
      search: {
        current_page: 1,
      },
    };
  },
  mounted() {
    this.search = {
      // editable parameters
      current_page: this.search_settings.current_page,
    };
  },
  computed: {
    ...mapState({
      projects: (state) => state.project.projects,
      projects_done: (state) => state.project.projects_done,
      projects_suspend: (state) => state.project.projects_suspend,
      search_settings: (state) => state.project.search_settings,
    }),

    table_fields() {
      let _fields = [
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        {
          key: "service_level",
          sortable: true,
          label: this.$t("menu.service_level"),
        },
        { key: "status", sortable: true },
        {
          key: "start_date",
          sortable: true,
          label: this.$t("menu.start_date"),
        },
        { key: "end_date", sortable: true, label: this.$t("menu.expiry_date") },
        // { key: 'updated_at',        sortable: true, label: '更新時間' },
        {
          key: "cropperiods",
          sortable: false,
          label: this.$t("n.cropping_season"),
        },
        // { key: 'details',           sortable: false, label: this.$t('menu.detail') },
        // { key: 'pic', sortable: true },
      ];
      return _fields;
    },

    table_items() {
      let _list = [];
      _list = _list.concat(this.projects);
      _list = _list.concat(this.projects_done);
      _list = _list.concat(this.projects_suspend);

      return _list;
    },
  },
  watch: {
    "search.current_page"() {
      this.getProjects();
    },
  },
  methods: {
    getProjects: function () {
      this.loading = true;
      const _query = {
        current_page: this.search.current_page,

        sort: this.search_settings.sort,
        per_page: this.search_settings.per_page,
        keyword: this.search_settings.keyword,
        types: this.search_settings.types,
      };
      this.$store
        .dispatch("project/getProjects", _query)
        .then((res) => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
#admin-project-table {
  min-width: 700px !important;
}
</style>

<style lang="scss" scoped>
.router-button {
  vertical-align: middle;
  padding: 4px 8px;

  .fa {
    vertical-align: middle;
    font-size: 1.6rem;
  }
}

.cropperiod-buttons {
  max-width: 30vw;
}

.stress-group {
  padding: 0px;
  padding-right: 3px;
}
</style>
